import { object, string } from 'yup';

export const claimBreweryFormSchema = object({
  firstName: string().trim().min(1, 'First name is required').required('First name is required'),
  lastName: string().trim().min(1, 'Last name is required').required('Last name is required'),
  breweryRole: string().trim().required('Role is required'),
  claimEmail: string().email('Enter a valid email').required('Email is required'),
  claimPassword: string()
    .min(6, 'At least 6 characters')
    .required('Password is required'),
});

export const claimBreweryInitialValues = {
  firstName: '',
  lastName: '',
  breweryRole: '',
  claimEmail: '',
  claimPassword: '',
};
